import LMSDispatcher from "../LMSDispatcher";
import * as CONSTANTS from "../../utilities/Constants";

class LoadingActions {

    async setLoading(data: boolean) {
        LMSDispatcher.dispatch({
            type: CONSTANTS.LOADING_INDICATOR,
            payload: data
        });
    }

    async setFormLoading(data: boolean) {
        LMSDispatcher.dispatch({
            type: CONSTANTS.FORM_LOADING_INDICATOR,
            payload: data
        });
    }
}

const loadingActions = new LoadingActions();
export default loadingActions;